import mount from "../../apps/modern/app/components/Base/Toast/helpers/mount";
import Toast from "../../apps/modern/app/components/Base/Toast/index.vue";

/**
 * Special thanks to https://github.com/MeForma
 *
 * Repository that was used to create this functionality: https://github.com/MeForma/vue-toaster
 * Demo: https://meforma.github.io/vue-toaster/
 */
const useToast = (globalOptions = {}) => {
  return {
    show(message: string, options = {}) {
      const localOptions = { message, ...options };
      const c = mount(Toast, { props: { ...globalOptions, ...localOptions } });
      return c;
    },
    success(message: string, options: Record<string, any> = {}) {
      options.type = "success";
      return this.show(message, options);
    },
    error(message: string, options: Record<string, any> = {}) {
      options.type = "danger";
      return this.show(message, options);
    },
    /**
     * Display a custom component in a toast
     * @param component The Vue component to render
     * @param options Toast options and component props
     */
    custom<T extends Component>(component: T, options: Record<string, any> = {}) {
      // Extract toast-specific options from general options
      const {
        position,
        duration,
        dismissible,
        pauseOnHover,
        onClose,
        onClick,
        ...componentProps
      } = options;

      // Create toast options object
      const toastOptions = {
        position,
        duration,
        dismissible,
        pauseOnHover,
        onClose,
        onClick,
        customComponent: component,
        customComponentProps: componentProps,
      };

      // Mount the toast with the custom component
      const c = mount(Toast, { props: { ...globalOptions, ...toastOptions } });
      return c;
    },
    destroy(toastInstance: { destroy: () => void }) {
      if (toastInstance && typeof toastInstance.destroy === "function") {
        toastInstance.destroy();
      }
    },
  };
};

export default useToast;
